// eslint-disable-next-line no-unused-vars
import React from 'react'
import { resolve } from 'styled-jsx/css'

export const formLabel = resolve`
    text-align: left;
    color: #757575;
    margin-bottom: 5px;
    font-size: 14px;
`
export const container = resolve`
    padding: 16px;
`

export const card = resolve`
    box-sizing: border-box;
    display: inline-block;
    position: relative;
    min-width: 200px;
    min-height: 218px;
    height: 100%;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 20px;
    background-color: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px,
        rgba(0, 0, 0, 0.12) 0px 1px 4px;
    border-radius: 5px;
    width: 100%;
`

export const actionsContainer = resolve`
    display: block;
    margin-top: 48px;
    margin-bottom: 16px;
`



// WEBPACK FOOTER //
// ./src/utils/styles/shared.js